var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading101_container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"dash first"}),_c('div',{staticClass:"dash seconde"}),_c('div',{staticClass:"dash third"}),_c('div',{staticClass:"dash fourth"})])])
}]

export { render, staticRenderFns }